<template>
  <div class="page-wrapper">
    <banner />
    <div class="page-container">
      <!-- 左侧内容区 -->
      <div class="content-left">
        <!-- 顶部导航筛选 -->
        <nav-filter />
        <!-- 教师基本信息 -->
        <div class="teacher-info">
          <div class="teacher-avatar">
            <img
              :src="picUrl + schoolInfo.pic1"
              :alt="schoolInfo.schoolname"
            />
          </div>
          <div class="info-content">
            <div class="name-location">
              <span class="teacher-name">{{ schoolInfo.schoolname }}</span>
              <span class="location"
                ><img
                  src="@/assets/images/position.png"
                  alt="位置"
                  class="pos-icon"
                />{{ schoolInfo.address }}</span
              >
            </div>
            <div class="info-container">
              <div class="info-grid">
                <div class="info-item">
                  <span class="label">性质：</span>
                  <el-tooltip
                    :content="schoolInfo.xingzhi"
                    placement="bottom-start"
                    :show-after="200"
                  >
                    <span class="value">{{ schoolInfo.xingzhi }}</span>
                  </el-tooltip>
                </div>
                <div class="info-item">
                  <span class="label">办学形式：</span>
                  <el-tooltip
                    :content="schoolInfo.xingshi"
                    placement="bottom-start"
                    :show-after="200"
                  >
                    <span class="value">{{ schoolInfo.xingshi }}</span>
                  </el-tooltip>
                </div>
                <div class="info-item">
                  <span class="label">层级：</span>
                  <el-tooltip
                    :content="schoolInfo.cengji"
                    placement="bottom-start"
                    :show-after="200"
                  >
                    <span class="value">{{ schoolInfo.cengji }}</span>
                  </el-tooltip>
                </div>
                <div class="info-item">
                  <span class="label">成立时间：</span>
                  <el-tooltip
                    :content="schoolInfo.cldate"
                    placement="bottom-start"
                    :show-after="200"
                  >
                    <span class="value">{{ schoolInfo.cldate }}年</span>
                  </el-tooltip>
                </div>
                <div class="info-item">
                  <span class="label">评级：</span>
                  <el-tooltip
                    :content="String(schoolInfo.pingji)"
                    placement="bottom-start"
                    :show-after="200"
                  >
                    <span class="value">{{ schoolInfo.pingji }}</span>
                  </el-tooltip>
                </div>
                <div class="info-item">
                  <span class="label">在校生数：</span>
                  <el-tooltip
                    :content="String(schoolInfo.studentcount)"
                    placement="bottom-start"
                    :show-after="200"
                  >
                    <span class="value">{{ schoolInfo.studentcount }}</span>
                  </el-tooltip>
                </div>
                <div class="info-item">
                  <span class="label">电话：</span>
                  <el-tooltip
                    :content="schoolInfo.tel"
                    placement="bottom-start"
                    :show-after="200"
                  >
                    <span class="value">{{ schoolInfo.tel }}</span>
                  </el-tooltip>
                </div>
                <div class="info-item">
                  <span class="label">网址：</span>
                  <el-tooltip
                    :content="schoolInfo.website"
                    placement="bottom-start"
                    :show-after="200"
                  >
                    <span class="value web-url">{{
                      schoolInfo.website || "--"
                    }}</span>
                  </el-tooltip>
                  <el-button
                    type="text"
                    class="copy-btn"
                    @click="copyWebsite"
                    v-if="schoolInfo.website"
                  >
                    <img
                      src="@/assets/images/fuzhi.png"
                      alt="复制"
                      class="copy-icon"
                    />
                  </el-button>
                </div>
              </div>
              <div class="stats">
                <div class="stat-item">
                  <img
                    src="@/assets/images/eye.png"
                    alt="浏览"
                    class="stat-icon"
                  />
                  <span class="stat-label">浏览</span>
                  <span class="stat-value">{{ schoolInfo.clickcount }}</span>
                </div>
                <div class="stat-item" @click="handleShare">
                  <img
                    src="@/assets/images/share.png"
                    alt="分享"
                    class="stat-icon"
                  />
                  <span class="stat-label">分享</span>
                  <span class="stat-value">{{ schoolInfo.sharecount }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 操作按钮组 -->
        <div class="action-buttons">
          <el-popover
            placement="bottom"
            trigger="click"
            popper-class="certificate-popover"
            width="auto"
          >
            <template #reference>
              <div class="button-item">
                <img src="@/assets/images/certificate.png" alt="查看证书" />
                <span>查看证书</span>
              </div>
            </template>
            <div class="certificate-content">
              <template v-if="schoolInfo.zhengshu">
                <img
                  :src="picUrl + schoolInfo.zhengshu"
                  alt="资质证书"
                  class="certificate-img"
                />
              </template>
              <div v-else class="empty-state">
                <img
                  src="@/assets/images/empty.png"
                  alt="暂无证书"
                  class="empty-icon"
                />
                <p class="empty-text">暂无证书信息</p>
              </div>
            </div>
          </el-popover>
          <el-popover
            placement="bottom"
            trigger="click"
            popper-class="certificate-popover"
            width="auto"
          >
            <template #reference>
              <div class="button-item">
                <img src="@/assets/images/certificate.png" alt="批文" />
                <span>批文</span>
              </div>
            </template>
            <div class="certificate-content">
              <template v-if="schoolInfo.piwen">
                <img
                  :src="picUrl + schoolInfo.piwen"
                  alt="批文"
                  class="certificate-img"
                />
              </template>
              <div v-else class="empty-state">
                <img
                  src="@/assets/images/empty.png"
                  alt="暂无批文"
                  class="empty-icon"
                />
                <p class="empty-text">暂无批文信息</p>
              </div>
            </div>
          </el-popover>
        </div>

        <!-- 学校简介 -->
        <div class="info-section resume-section">
          <div class="section-header">
            <img
              src="@/assets/images/resume.png"
              alt="学校简介"
              class="header-icon"
            />
            <span class="header-text">学校简介</span>
          </div>
          <div class="section-content">
            {{ schoolInfo.jianjie }}
          </div>
        </div>

        <!-- 组织机构 -->
        <div class="text-materials-section">
          <div class="section-header">
            <div class="header-left">
              <div class="title-area">
                <img
                  src="@/assets/images/book.png"
                  alt="组织机构"
                  class="header-icon"
                />
                <span class="header-text">组织机构</span>
              </div>
            </div>
          </div>
          <div class="org-structure-rows">
            <div v-for="item in orgList" :key="item.name" class="org-row">
              <div class="org-title">{{ item.orgname }}</div>
              <div class="org-description">{{ item.orgvalue }}</div>
            </div>
          </div>
        </div>

        <!-- 信息公告 -->
        <div class="free-videos-section">
          <div class="section-header">
            <div class="header-left">
              <div class="title-area">
                <img
                  src="@/assets/images/video.png"
                  alt="在校生"
                  class="header-icon"
                />
                <span class="header-text">在校生</span>
              </div>
            </div>
          </div>
          <div class="section-content">
            <div class="department-section" v-for="(item, idx) in zxsList" :key="idx">
              <div class="department-header">{{ item.nianji }}</div>
              <div class="class-list">
                <div class="class-item" v-for="(item, idx) in item.xiangxi" :key="idx">{{ item.banji }}</div>
              </div>
            </div>
          </div>
        </div>

        <!-- 校友中心模块 -->
        <div class="alumni-center-section">
          <div class="section-header">
            <div class="header-left">
              <div class="title-area">
                <img
                  src="@/assets/images/xiaoyou.png"
                  alt="校友中心"
                  class="header-icon"
                />
                <span class="header-text">校友中心</span>
              </div>
            </div>
          </div>
          <div class="section-content">
            <div class="alumni-leader"><b>负责人：</b>{{ alumnsBasic.fuzeren }}</div>
            <div class="alumni-row">
              <div class="alumni-btn">校友联谊</div>
              <div class="alumni-desc">
                {{ alumnsBasic.lianyi }}
              </div>
            </div>
            <div class="alumni-row alumni-row-notice">
              <div class="alumni-btn">中心公告</div>
              <div class="alumni-more" @click="goCenterNoticList">更多&gt;&gt;</div>
            </div>
            <div class="alumni-notice-list">
              <div class="alumni-notice-item" @click="goSCenterDetail(newNoticeInfo.id)">
                <div>
                  <span class="alumni-notice-index">01</span>
                  <span class="alumni-notice-title">{{ newNoticeInfo.title }}</span>
                </div>
                <div class="alumni-notice-content">
                  {{ newNoticeInfo.content }}
                </div>
              </div>
            </div>

            <div class="alumni-row alumni-row-graduates">
              <div class="alumni-btn">毕业校友(毕业届){{biyeshengInfo && biyeshengInfo.length && biyeshengInfo[0].jieshu}}届</div>
              <div class="alumni-more" @click="goMateCenter">更多&gt;&gt;</div>
            </div>
            <div class="alumni-class-list">
              <div class="alumni-class-item" v-for="(item, idx) in biyeshengInfo" :key="idx">{{ item.banji }}</div>
            </div>
          </div>
        </div>
        <!-- 校园生活 -->
        <div class="school-life-section">
          <div class="section-header">
            <div class="header-left">
              <img
                src="@/assets/images/xysh.png"
                alt="校园生活"
                class="header-icon"
              />
              <span class="header-text">校园生活</span>
            </div>
            <div class="header-right" @click="goLifeCenter">更多&gt;&gt;</div>
          </div>
          <div class="section-content">
            <!-- <div class="school-life-list">
              <div class="school-life-item" v-for="(item, idx) in 4" :key="idx">
                <img src="@/assets/images/ad.png" class="life-img" />
              </div>
            </div>
            <div class="life-info">
              <div class="life-title">{{ schoolLifeList.title }}</div>
              <div class="life-desc">{{ schoolLifeList.desc }}</div>
            </div> -->
          </div>
        </div>
        <!-- 信息公告 -->
        <div class="school-life-section">
          <div class="section-header">
            <div class="header-left xxgg-header">
              <img
                src="@/assets/images/xxgg.png"
                alt="信息公告"
                class="header-icon"
              />
              <span class="header-text">信息公告</span>
            </div>
            <div class="header-right" @click="goNoticList">更多&gt;&gt;</div>
          </div>
          <div class="section-content notice-list">
            <div class="notice-item" v-for="(item, idx) in gonggaoInfo" :key="idx" @click="goNoticeDetail(item.id)">
              <img src="@/assets/images/xx-color.png" class="notice-icon" />
              <div class="notice-main">
                <div class="notice-title">{{ item.title }}</div>
                <div class="notice-desc">{{ item.content }}</div>
              </div>
            </div>
          </div>
        </div>
        <!-- 风采 -->
        <div class="school-life-section">
          <div class="section-header">
            <div class="header-left fengcai-header">
              <img
                src="@/assets/images/fengcai.png"
                alt="风采"
                class="header-icon"
              />
              <span class="header-text">风采</span>
            </div>
            <div class="header-right" @click="goMienList">更多&gt;&gt;</div>
          </div>
          <div class="section-content">
            <div class="fengcai-list">
              <div class="fengcai-item" v-for="(item, idx) in fengcaiList" :key="idx" @click="goMienDetail(item.id)">
                <img :src="picUrl + item.pic" class="fengcai-img" />
                <div class="fengcai-info">
                  <div class="fengcai-title">{{ item.title }}</div>
                  <div class="fengcai-desc">{{ item.content }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 右侧广告区 -->
      <!-- <ad-sidebar /> -->
      <v-right :marketBannerSmall="marketBannerSmall" :marTop="false"></v-right>
    </div>
     <!-- 分享弹窗组件 -->
    <share-dialog
      :visible="showShareDialog"
      :share-data="shareDialogData"
      @close="handleShareClose"
      @share-success="handleShareSuccess"
    />
  </div>
</template>

<script>
import Banner from '@/components/common/Banner'
// import AdSidebar from '@/components/common/AdSidebar'
import vRight from '@/components/education/Right2'
import NavFilter from '@/components/teacher/NavFilter'
import ShareDialog from '@/components/common/ShareDialog.vue'
import { getEduDetails, getLastFCGGXX, getSchoolZuzhi, getSchoolZxs, getAlumnsBasic, getNewNoticeOne, getNewBiyeshengOne } from '@/axios/education'
import url from '@/axios/url'
import sign from '@/auth/sign'

export default {
  name: 'TeacherDetail',
  components: {
    Banner,
    // AdSidebar,
    vRight,
    ShareDialog,
    NavFilter
  },
  data () {
    return {
      picUrl: url.picUrl,
      appid: 'wzwebapp',
      timestamp: parseInt(new Date().getTime() / 1000),
      id: parseInt(this.$route.query.id),
      type: parseInt(this.$route.query.type),
      schoolInfo: {
        name: '',
        position: '',
        political: '',
        school: '',
        rating: '',
        jobStatus: '',
        yearsOfTeaching: '',
        location: '',
        tel: '',
        website: '',
        views: '0',
        shares: '0',
        zhici: '',
        jianli: '',
        zhaopian: '',
        wenping: '',
        zhengjian: ''
      },
      orgList: [],
      zxsList: [],
      alumnsBasic: {},
      newNoticeInfo: {},
      biyeshengInfo: {},
      gonggaoInfo: [],
      // 新增：校园生活内容数据
      schoolLifeList: [],
      // 新增：风采内容数据
      fengcaiList: [],
      showShareDialog: false
    }
  },
  computed: {
    marketBannerSmall () {
      return this.$store.getters.travleBanner.sbanner
    },
    // 分享弹窗数据
    shareDialogData () {
      return {
        title: this.schoolInfo.schoolname || '',
        teacherName: this.schoolInfo.schoolname || '',
        teacherId: this.id || null,
        coverImage: this.schoolInfo.pic1 || '',
        picUrl: this.picUrl,
        type: this.type,
        appid: this.appid,
        url: window.location.href
      }
    }
  },
  created () {
    this.getTeacherDetails()
    this.lastFCGGXXHandle()
    this.getSchoolZuzhi()
    this.getSchoolZxs()
    this.getAlumnsBasic()
    this.getNewNoticeOne()
    this.getNewBiyeshengOne()
  },
  methods: {
    goNoticeDetail (id) {
      this.$router.push({ name: 'NoticeDetail', query: { id, type: this.type } })
    },
    goMienDetail (id) {
      this.$router.push({
        name: 'SchoolLifeInfo',
        query: {
          id,
          type: this.type,
          is_mein: 1
        }
      })
    },
    goSCenterDetail (id) {
      this.$router.push({ name: 'SchoolCenterNoticeInfo', query: { id, type: this.type } })
    },
    handleShare () {
      this.showShareDialog = true
    },
    handleShareClose () {
      this.showShareDialog = false
    },
    // 分享成功回调
    handleShareSuccess () {
      this.getTeacherDetails()
    },
    getNewNoticeOne () {
      const params = {
        appid: this.appid,
        timestamp: this.timestamp,
        id: this.id,
        stype: 1
      }
      const signO = sign(params)
      params.sign = signO
      getNewNoticeOne(params).then((res) => {
        if (res.data && res.data.code === 200) {
          const data = res.data.data
          this.newNoticeInfo = data
        }
      })
    },
    getNewBiyeshengOne () {
      const params = {
        appid: this.appid,
        timestamp: this.timestamp,
        id: this.id,
        stype: 1
      }
      const signO = sign(params)
      params.sign = signO
      getNewBiyeshengOne(params).then((res) => {
        if (res.data && res.data.code === 200) {
          const data = res.data.data
          this.biyeshengInfo = data
        }
      })
    },
    getAlumnsBasic () {
      const params = {
        appid: this.appid,
        timestamp: this.timestamp,
        id: this.id,
        stype: 1
      }
      const signO = sign(params)
      params.sign = signO
      getAlumnsBasic(params).then((res) => {
        if (res.data && res.data.code === 200) {
          const data = res.data.data
          this.alumnsBasic = data
        }
      })
    },
    getSchoolZxs () {
      const params = {
        appid: this.appid,
        timestamp: this.timestamp,
        id: this.id,
        stype: 1
      }
      const signO = sign(params)
      params.sign = signO
      getSchoolZxs(params).then((res) => {
        if (res.data && res.data.code === 200) {
          const data = res.data.data
          this.zxsList = data
        }
      })
    },
    getSchoolZuzhi () {
      const params = {
        appid: this.appid,
        timestamp: this.timestamp,
        id: this.id,
        stype: 1
      }
      const signO = sign(params)
      params.sign = signO
      getSchoolZuzhi(params).then((res) => {
        if (res.data && res.data.code === 200) {
          const data = res.data.data
          this.orgList = data
        }
      })
    },
    getTeacherDetails () {
      const params = {
        appid: this.appid,
        timestamp: this.timestamp,
        id: this.id,
        type: this.type
      }
      const signO = sign(params)
      params.sign = signO

      getEduDetails(params).then((res) => {
        if (res.data && res.data.code === 200) {
          const data = res.data.data
          this.schoolInfo = data
        }
      })
    },
    // 获取5条最新的学校风采、校园公告、校园信息
    lastFCGGXXHandle () {
      // 校园信息 ntype: 1
      const params1 = {
        appid: this.appid,
        timestamp: parseInt(new Date().getTime() / 1000),
        id: this.id,
        stype: '1',
        ntype: '1'
      }
      params1.sign = sign(params1)
      getLastFCGGXX(params1).then((res) => {
        if (res.data.code === 200) {
          this.schoolLifeList = res.data.data
        }
      })

      // 公告 ntype: 2
      const params2 = {
        appid: this.appid,
        timestamp: parseInt(new Date().getTime() / 1000),
        id: this.id,
        stype: '1',
        ntype: '2'
      }
      params2.sign = sign(params2)
      getLastFCGGXX(params2).then((res) => {
        if (res.data.code === 200) {
          this.gonggaoInfo = res.data.data
        }
      })

      // 风采 ntype: 3
      const params3 = {
        appid: this.appid,
        timestamp: parseInt(new Date().getTime() / 1000),
        id: this.id,
        stype: '1',
        ntype: '3'
      }
      params3.sign = sign(params3)
      getLastFCGGXX(params3).then((res) => {
        if (res.data.code === 200) {
          this.fengcaiList = res.data.data
        }
      })
    },
    toGonggaoList () {
      this.$router.push({
        name: 'NoticeList',
        query: { id: this.id }
      })
    },
    toGonggaoDeatil (id) {
      this.$router.push({
        name: 'NoticeDetail',
        query: { id }
      })
    },
    copyWebsite () {
      if (this.schoolInfo.website) {
        navigator.clipboard
          .writeText(this.schoolInfo.website)
          .then(() => {
            this.$message.success('复制成功')
          })
          .catch(() => {
            this.$message.error('复制失败')
          })
      }
    },
    goMateCenter () {
      // 跳转到校友中心页面
      this.$router.push({
        name: 'Schoolmate',
        query: {
          school_id: this.id,
          type: this.type
        }
      })
    },
    goLifeCenter () {
      this.$router.push({
        name: 'SchoolLife',
        query: {
          school_id: this.id,
          type: this.type
        }
      })
    },
    goMienList () {
      this.$router.push({
        name: 'SchoolMien',
        query: {
          school_id: this.id,
          type: this.type
        }
      })
    },
    goNoticList () {
      this.$router.push({
        name: 'SchoolNotic',
        query: {
          school_id: this.id,
          type: this.type
        }
      })
    },
    goCenterNoticList () {
      this.$router.push({
        name: 'SchoolCenterNotice',
        query: {
          school_id: this.id,
          type: this.type
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.page-wrapper {
  background: #f8f8f8;
  min-height: 100vh;
  padding: 0 0 20px;

  .page-container {
    width: 1200px;
    margin: 20px auto 0;
    display: flex;
    gap: 14px;

    .content-left {
      flex: 1;
      background: #ffffff;
      border-radius: 4px;
      box-shadow: 0 1px 4px rgba(0, 0, 0, 0.05);
      padding: 20px;
      max-width: 810px;

      .teacher-info {
        background: transparent;
        box-shadow: none;
        padding: 0;
        display: flex;
        gap: 20px;
        margin-bottom: 20px;

        .teacher-avatar {
          width: 144px;
          height: 144px;
          border-radius: 6px;
          overflow: hidden;
          flex-shrink: 0;

          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
        }

        .info-content {
          flex: 1;

          .name-location {
            display: flex;
            align-items: center;
            margin-bottom: 12px;

            .teacher-name {
              font-size: 16px;
              color: #ef8432;
              font-weight: bold;
              margin-right: 50px;
            }

            .location {
              font-size: 13px;
              color: #666666;
            }

            .pos-icon {
              width: 14px;
              margin-right: 6px;
            }
          }

          .info-container {
            background: transparent;
            padding: 0;

            .info-grid {
              margin-bottom: 16px;
              display: grid;
              grid-template-columns: repeat(3, 1fr);
              gap: 10px;

              .info-item {
                display: flex;
                align-items: center;
                .web-url {
                  color: #0d52f8 !important;
                }
                .label {
                  color: #af8338;
                  font-size: 13px;
                  margin-right: 8px;
                  white-space: nowrap;
                }

                .value {
                  color: #333333;
                  font-size: 13px;
                  max-width: 120px;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                }

                .copy-btn {
                  padding: 2px 4px;
                  margin-left: 4px;

                  .copy-icon {
                    width: 14px;
                    height: 14px;
                  }

                  &:hover {
                    background-color: #f5f5f5;
                  }
                }
              }
            }

            .stats {
              display: grid;
              grid-template-columns: repeat(3, 1fr);
              gap: 10px;
              margin-top: 16px;

              .stat-item {
                display: flex;
                width: 50%;
                align-items: center;
                cursor: pointer;

                .stat-icon {
                  width: 16px;
                  height: 16px;
                  margin-right: 4px;
                }

                .stat-value {
                  color: #ef8432;
                  font-size: 13px;
                }

                .stat-label {
                  color: #3d3d3d;
                  font-size: 13px;
                  margin-right: 4px;
                }
              }
            }
          }
        }
      }

      .action-buttons {
        display: flex;
        gap: 24px;
        margin-bottom: 20px;
        padding: 0;
        background: transparent;
        box-shadow: none;
        align-items: center;
        justify-content: center;

        .button-item {
          flex: 1;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 12px;
          height: 50px;
          min-width: 182px;
          background: #ffffff;
          cursor: pointer;
          transition: all 0.3s;
          border: 1px solid #f0f0f0;
          border-radius: 11px;

          img {
            width: 38px;
            height: 38px;
          }

          span {
            font-size: 14px;
            color: #333333;
            font-weight: bold;
          }

          &:hover {
            background: #f8f8f8;
          }
        }
      }
    }
  }
}

.info-section {
  background: #ffffff;
  border-radius: 8px;
  margin-bottom: 16px;
  padding: 16px;
  border: 1px solid #f0f0f0;

  .section-header {
    display: flex;
    align-items: center;
    margin-bottom: 16px;

    .header-icon {
      width: 20px;
      height: 20px;
      margin-right: 6px;
    }

    .header-text {
      font-size: 16px;
      color: #3db963;
      font-weight: 500;
    }
  }

  .section-content {
    color: #666666;
    font-size: 14px;
    line-height: 1.6;
  }

  &.resume-section {
    position: relative;
    overflow: hidden;

    &::before {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      width: 110px;
      height: 33px;
      background: #3db963;
      border-radius: 0 0 16px 0;
      z-index: 0;
    }

    .section-header {
      position: absolute;
      top: 0;
      left: 0;
      z-index: 1;
      height: 33px;
      display: flex;
      align-items: center;
      padding-left: 16px;

      .header-icon {
        width: 18px;
        height: 18px;
        margin-right: 6px;
      }

      .header-text {
        color: #ffffff;
        font-size: 14px;
        font-weight: normal;
      }
    }

    .section-content {
      position: relative;
      z-index: 1;
      color: #666666;
      font-size: 14px;
      line-height: 1.8;
      padding: 40px 16px 16px;
    }
  }

  &.course-section {
    &::before {
      background: #ef8432;
    }
  }
}

.text-materials-section {
  position: relative;
  overflow: hidden;
  background: #ffffff;
  border: 1px solid #f0f0f0;
  border-radius: 8px;
  margin-bottom: 16px;

  .section-header {
    position: relative;
    z-index: 1;
    height: 33px;
    display: flex;
    align-items: center;
    margin: 0;
    justify-content: space-between;

    .header-left {
      display: flex;
      align-items: center;
      height: 100%;
      border-radius: 0 0 8px 0;
      font-size: 13px;

      .title-area {
        display: flex;
        align-items: center;
        background: #3499e1;
        height: 100%;
        padding: 0 20px;
        border-radius: 0 0 16px 0;

        .header-icon {
          width: 18px;
          height: 18px;
          margin-right: 6px;
        }

        .header-text {
          color: #ffffff;
          font-size: 14px;
          font-weight: normal;
        }
      }
    }
  }
}

.org-structure-rows {
  padding: 24px 16px;
}
.org-row {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}
.org-row:last-child {
  margin-bottom: 0;
}
.org-title {
  background: #eaf4fd;
  border-radius: 4px;
  padding: 4px 8px;
  color: #3499e1;
  font-size: 14px;
  flex-shrink: 0;
  margin-right: 16px;
  min-width: 100px;
  text-align: center;
  font-weight: bold;
  border: 0.5px solid rgba(52, 153, 225, 0.5);
}
.org-description {
  font-size: 14px;
  color: #333;
  line-height: 1.6;
}

.free-videos-section {
  position: relative;
  overflow: hidden;
  background: #ffffff;
  border: 1px solid #f0f0f0;
  border-radius: 8px;
  margin-bottom: 16px;

  .section-header {
    position: relative;
    z-index: 1;
    height: 33px;
    display: flex;
    align-items: center;
    margin: 0;
    justify-content: space-between;

    .header-left {
      display: flex;
      align-items: center;
      height: 100%;
      border-radius: 0 0 8px 0;
      font-size: 13px;

      .title-area {
        display: flex;
        align-items: center;
        background: #3fbabe;
        height: 100%;
        padding: 0 20px;
        border-radius: 0 0 16px 0;

        .header-icon {
          width: 18px;
          height: 18px;
          margin-right: 6px;
        }

        .header-text {
          color: #ffffff;
          font-size: 14px;
          font-weight: normal;
        }
      }
    }

    .more {
      padding: 0 16px;
      color: #666666;
      font-size: 14px;
      height: 100%;
      display: flex;
      align-items: center;
      cursor: pointer;
    }
  }

  .section-content {
    padding: 16px;

    .department-section {
      .department-header {
        display: inline-block;
        padding: 4px 12px;
        background: rgba(63, 186, 190, 0.1);
        border: 0.5px solid rgba(63, 186, 190, 0.5);
        color: #3fbabe;
        font-size: 14px;
        border-radius: 4px;
        margin-bottom: 2px;
        font-weight: bold;
      }

      .class-list {
        display: flex;
        flex-wrap: wrap;
        gap: 12px;
        margin-bottom: 6px;

        .class-item {
          padding: 6px 16px;
          color: #666;
          font-size: 14px;
          cursor: pointer;
          transition: all 0.3s;

          &:hover {
            background: #e8f6ff;
            color: #333;
            border-color: #d0e8ff;
          }
        }
      }
    }
  }
}

.certificate-popover {
  padding: 0;
  background: rgba(0, 0, 0, 0.7);
  border: none;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);

  .certificate-content {
    width: 400px;
    min-height: 200px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 4px;

    .certificate-img {
      width: 400px;
      height: auto;
      display: block;
      border-radius: 8px;
    }

    .empty-state {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      padding: 40px 0;

      .empty-icon {
        width: 150px;
        height: 150px;
        margin-bottom: 16px;
      }

      .empty-text {
        font-size: 14px;
        color: #999;
        margin: 0;
      }
    }
  }
}

/* 校友中心模块样式优化 */
.alumni-center-section {
  position: relative;
  overflow: hidden;
  background: #ffffff;
  border: 1px solid #f0f0f0;
  border-radius: 8px;
  margin-bottom: 16px;

  .section-header {
    position: relative;
    z-index: 1;
    height: 33px;
    display: flex;
    align-items: center;
    margin: 0;
    justify-content: space-between;

    .header-left {
      display: flex;
      align-items: center;
      height: 100%;
      border-radius: 0 0 8px 0;
      font-size: 13px;

      .title-area {
        display: flex;
        align-items: center;
        background: #ef8432;
        height: 100%;
        padding: 0 20px;
        border-radius: 0 0 16px 0;

        .header-icon {
          width: 18px;
          height: 18px;
          margin-right: 6px;
        }

        .header-text {
          color: #ffffff;
          font-size: 14px;
          font-weight: normal;
        }
      }
    }
  }
  .section-content {
    position: relative;
    z-index: 1;
    color: #666666;
    font-size: 14px;
    line-height: 1.8;
    padding: 16px;

    .alumni-leader {
      color: #333;
      font-size: 14px;
      font-weight: bold;
      margin-bottom: 8px;
    }
    .alumni-row {
      margin-bottom: 10px;
    }
    .alumni-btn {
      display: inline-block;
      padding: 2px 18px;
      border-radius: 4px;
      font-size: 14px;
      font-weight: bold;
      border: 0.5px solid rgba(239, 132, 50, 0.5);
      background: rgba(239, 132, 50, 0.1);
      color: #ef8432;
      margin: 10px 0;
    }
    .alumni-desc {
      color: #3d3d3d;
      font-size: 14px;
      line-height: 1.7;
    }
    .alumni-row-notice {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
    .alumni-more {
      color: #f89b3d;
      font-size: 13px;
      margin-left: auto;
      cursor: pointer;
      font-weight: bold;
    }
    .alumni-notice-list {
      margin-bottom: 10px;
      margin-top: 6px;
    }
    .alumni-notice-item {
      margin-bottom: 4px;
      padding-bottom: 7px;
      font-size: 14px;
      border-bottom: 1px dashed #e8e8e8;
    }
    .alumni-notice-index {
      color: #3d3d3d;
      font-weight: bold;
      margin-right: 8px;
      font-size: 15px;
    }
    .alumni-notice-title {
      color: #3d3d3d;
      font-weight: bold;
      margin-right: 8px;
      font-size: 14px;
    }
    .alumni-notice-content {
      color: #3d3d3d;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      font-size: 14px;
      margin-top: 10px;
    }
    .alumni-row-graduates {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
    .alumni-class-list {
      display: flex;
      justify-content: flex-start;
      gap: 10px 45px;
      flex-wrap: wrap;
    }
    .alumni-class-item {
      color: #3d3d3d;
      font-size: 15px;
    }
  }
}
.school-life-section {
  position: relative;
  overflow: hidden;
  background: #ffffff;
  border: 1px solid #f0f0f0;
  border-radius: 8px;
  margin-bottom: 16px;

  .section-header {
    position: relative;
    z-index: 1;
    height: 33px;
    display: flex;
    align-items: center;
    margin: 0;
    justify-content: space-between;

    .header-left {
      display: flex;
      align-items: center;
      background: #3db963;
      height: 100%;
      padding: 0 20px;
      border-radius: 0 0 16px 0;

      .header-icon {
        width: 18px;
        height: 18px;
        margin-right: 6px;
      }

      .header-text {
        color: #ffffff;
        font-size: 14px;
        font-weight: normal;
      }
    }
    .xxgg-header{
      background: #3499E1 !important;
    }
    .fengcai-header{
      background: #3FBABE !important;
    }
    .header-right {
      color: #f89b3d;
      font-size: 13px;
      margin-left: auto;
      cursor: pointer;
      font-weight: bold;
      padding-right: 16px;
    }
  }

  .section-content {
    color: #666666;
    font-size: 14px;
    line-height: 1.6;
    padding: 16px;
  }
}
.school-life-list {
  display: flex;
  gap: 16px;
  .school-life-item {
    width: 25%;
    .life-img {
      width: 100%;
      height: 140px;
      object-fit: cover;
    }
  }
}
.life-info {
  padding: 12px 0;
  .life-title {
    font-weight: bold;
    font-size: 15px;
    margin-bottom: 6px;
    color: #222;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .life-desc {
    color: #666;
    font-size: 13px;
    line-height: 1.5;
    /* height: 38px; */
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    word-break: break-all;
  }
}
.notice-list {
  padding: 0 8px;
  .notice-item {
    display: flex;
    align-items: flex-start;
    padding: 16px 0;
    border-bottom: 1px solid #f0f0f0;
    &:last-child {
      border-bottom: none;
    }
    .notice-icon {
      width: 22px;
      height: 22px;
      margin-right: 14px;
      margin-top: 2px;
      flex-shrink: 0;
    }
    .notice-main {
      flex: 1;
      .notice-title {
        font-weight: bold;
        color: #222;
        font-size: 15px;
        margin-bottom: 4px;
      }
      .notice-desc {
        color: #666;
        font-size: 13px;
        line-height: 1.6;
        word-break: break-all;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
      }
    }
  }
}
.fengcai-list {
  display: flex;
  flex-direction: column;
  gap: 18px;
}
.fengcai-item {
  display: flex;
  align-items: flex-start;
  gap: 16px;
  padding: 10px 16px;
  border-bottom: 1px solid #f0f0f0;
  &:last-child {
      border-bottom: none;
    }
}
.fengcai-img {
  width: 160px;
  height: 80px;
  object-fit: cover;
  border-radius: 6px;
  flex-shrink: 0;
}
.fengcai-info {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.fengcai-title {
  font-weight: bold;
  font-size: 16px;
  color: #222;
  margin-bottom: 6px;
  line-height: 1.2;
}
.fengcai-desc {
  color: #666;
  font-size: 13px;
  line-height: 1.6;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
</style>



// WEBPACK FOOTER //
// src/components/teacher/schoolDetail.vue